<li *transloco="let t" class="mt-4">
  <div class="d-flex flex-wrap justify-content-between align-items-center mb-6 pt-1">
    <h4 class="me-md-auto fw-bold mb-0">{{ material.title }}</h4>
    <a *ngIf="material.downloadAll" (click)="downloadAll(material.uuid)" class="btn btn-outline-dark d-flex align-items-center">
      <i aria-hidden="true" class="me-1" [class]="icons.download"></i>
      {{ t('support/downloadAll') }}
    </a>
  </div>

  <div class="d-flex flex-wrap mb-5 text-center card-wrapper isophi-work-sheets">
    <app-material-single *ngFor="let document of material.documents" [document]="document"></app-material-single>
  </div>
</li>
